import { css } from 'styled-components';

export default css`
  button {
    width: min-content;
  }
`;
